import { MerchantTypeEnum } from './../../../../../models/enums/lokal/merchant-type.enum';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantService, NationalityService } from 'app/services';
import { Salutation, Suffix, CompanyPosition, MerchantServiceTypeEnum, MerchantPromoTypeEnum,ProposalCreation,
    Commission, PromoCommission, CommissionType} from 'app/models';
import { MartOnboardingComponent } from 'app/components/home/partners/mart-onboarding/mart-onboarding.component';
import {MenuHomeEnum} from 'app/home';
import { OnboardingPartner } from 'app/models/merchant/onboarding-partner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Utils } from 'app/utils/utils';

enum CreatePartnerTab {
    CompanyDetails = 1,
    PersonalDetails = 2,
    Service = 3,
    Proposal = 4,
    Preview = 5
}

@Component({
    selector: 'create-mart-partner',
    templateUrl: './create-mart-partner.component.html',
    styleUrls: ['./create-mart-partner.component.scss',
        '../../../../../../styles/sidebar.scss',
        '../../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class CreateMartPartnerComponent implements OnInit {
    customPickupCommissionRate: any;
    customPickupValue: any;
    customDeliveryCommissionRate: any;
    customDeliveryValue: any;
    @Input()
    set _menuHomeEnumActive(value: MenuHomeEnum) {
        this.menuHomeEnumActive = value;
    }

    @Input()
    set _showCreateMartPartnerSideBar(value: boolean) {
        this.showCreateMartPartnerSideBar = value;
    }

    @Input() public martOnboardingComponent!: MartOnboardingComponent;
    @Output() changedShowCreateMartPartnerSideBarEmit = new EventEmitter<boolean>();
    changedShowCreateMartPartnerSideBar(increased: any) {
        this.changedShowCreateMartPartnerSideBarEmit.emit(increased);
    }
    @Input() public showCreateMartSideBar: boolean = false;
    @Output() changedShowCreateMartSideBarEmit = new EventEmitter<boolean>();
    changedShowCreateMartSideBar(increased: any) {
        this.changedShowCreateMartSideBarEmit.emit(increased);
    }

    constructor(
        private messageService: MessageService,
        private merchantService: MerchantService,
        private nationalityService: NationalityService,
        private formBuilder: FormBuilder,) {
    }

    public menuHomeEnumActive!: MenuHomeEnum;
    public menuHomeEnum = MenuHomeEnum;

    public showCreateMartPartnerSideBar: boolean = false;
    public loading: boolean = false;

    public createPartnerTab = CreatePartnerTab;
    public activeCreatePartnerTab: CreatePartnerTab = CreatePartnerTab.CompanyDetails;

    public merchantServiceTypeEnum = MerchantServiceTypeEnum;
    public merchantPromoTypeEnum = MerchantPromoTypeEnum;
    public companyPositions = CompanyPosition.CompanyPositionList;
    public salutations = Salutation.SalutationList;
    public suffixes = Suffix.SuffixList;
    public pickupCommissions: Array<Commission> = ProposalCreation.PickupCommissionList;
    public deliveryCommissions: Array<Commission> = ProposalCreation.DeliveryCommissionList;
    public promoOffer: Array<PromoCommission> = ProposalCreation.PromoOfferList;
    public merchant: any = {};
    public natioanlities: any = {};
    public addresses: any[] = [];
    public selectedDeliveryCommission!: Commission;
    public selectedPickupCommission!: Commission;
    public customDeliveryMDR!: number;
    public customDeliverRate!: string;
    public customPickupMDR!: number;
    public customPickupRate!: string;
    public customPromo!: string;
    public customDuration!: string;
    public customPromoAdd!: string;
    public currentDay: Date = new Date();

    ngOnInit(): void {
        this.getNationalities();
        this.initializePartnerForm();
    }

    public getNationalities() {
        this.nationalityService.getIsActiveNationalities(null, this.messageService).then(data => {
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.natioanlities = data.Items;
        });
    }
    public merchantCompany!: OnboardingPartner;
    @Input()
    set _merchantCompany(obj: any) {
        this.merchantCompany = obj;
        this.initializePartnerForm();
    }
    partnerDetailsForm!: FormGroup;
    personalForm!: FormGroup;
    serviceForm!: FormGroup;
    proposalForm!: FormGroup;

    private initializePartnerForm(): void {
        this.partnerDetailsForm = new FormGroup({
          BusinessName: new FormControl('', Validators.required),
          BusinessAddress: new FormControl('', Validators.required),
          BusinessCity: new FormControl('', Validators.required),
          BusinessPostalCode: new FormControl('', [
            Validators.required,
            Validators.pattern(Utils.zipCodeRegex),
          ]),
          TradingName: new FormControl('', Validators.required), // Add validation
          BusinessPhone: new FormControl('',[
                Validators.required,
                Validators.pattern(Utils.phMobileNumberRegex),
            ]),
          BusinessEmail: new FormControl('', [Validators.required,Validators.email]),
        });

        this.personalForm = new FormGroup({
            CompanyPosition: new FormControl('', Validators.required),
            Salutation: new FormControl('', Validators.required),
            FirstName: new FormControl('', Validators.required),
            LastName: new FormControl('', Validators.required),
            City: new FormControl('', Validators.required),
            Birthday:new FormControl('', Validators.required),
            Address:new FormControl('', Validators.required),
            PostalCode: new FormControl('',[
                Validators.required,
                Validators.pattern(Utils.zipCodeRegex),
              ]),
            Phone:new FormControl('', [
                Validators.required,
                Validators.pattern(Utils.phMobileNumberRegex),
              ]),
            Email:new FormControl('', [Validators.required, Validators.email]),
            NationalityId: new FormControl('', Validators.required),
          });

        this.serviceForm = new FormGroup({
            MerchantServiceTypes: new FormControl('', Validators.required)
          });

        this.proposalForm = new FormGroup({
            BranchQuantity: new FormControl('', Validators.required),
            DeliveryCommission: new FormControl('', Validators.required),
            customDeliveryMDR:  new FormControl(''),
            customDeliverRate:  new FormControl(''),
            PickupCommission: new FormControl('', Validators.required),
            customPickupRate: new FormControl(''),
            customPickupMDR: new FormControl(''),
            MerchantPromo: new FormControl(''),
            PromoOffer: new FormControl('', Validators.required),
            customPromo: new FormControl(''),
            customDuration: new FormControl(''),
            customPromoAdd: new FormControl(''),
        });
      }

    public validateField(fieldName: string) {
        const control = this.partnerDetailsForm.get(fieldName);
        if (control) {
            control.markAsTouched();
            control.updateValueAndValidity();
        }
    }

    public nextTab(tab: CreatePartnerTab) {
        this.activeCreatePartnerTab = tab;
    }
    public createMerchant() {
        this.loading = true;
        const dto: any = {
            ...this.partnerDetailsForm.value,
            ...this.personalForm.value,
            ...this.proposalForm.value,
            MerchantServiceTypes: this.serviceForm.get('MerchantServiceTypes')?.value,
            MerchantType: this.menuHomeEnumActive === MenuHomeEnum.FoodOnboarding ? MerchantTypeEnum.Eats : MerchantTypeEnum.Marts
        };
        if (!dto.BusinessName || !dto.BusinessPhone || !dto.TradingName || !dto.BusinessEmail ||
            !dto.CompanyPosition || !dto.Salutation || !dto.FirstName ||
            !dto.LastName || !dto.Birthday || !dto.Phone || !dto.Email) {
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Fill all required fields.' });
            this.loading = false;
            return;
        }
        this.merchantService.createMerchant(dto, this.menuHomeEnumActive, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }
            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data?.ErrorMessage || 'Something went wrong' });
                return;
            }
            this.loading = false;
            this.martOnboardingComponent.getMerchants(0);
            this.changedShowCreateMartSideBar(false);
            this.cancel();
        });
    }
    public search(event: any) {
        const query = event.query;
        const service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions({ input: query }, (predictions, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                this.addresses = predictions ? predictions.map((prediction) => prediction.description) : [];
            } else {
                this.addresses = [];
            }
        });
    }

    cancel() {
        this.changedShowCreateMartPartnerSideBar(!this.showCreateMartPartnerSideBar);
        this.changedShowCreateMartSideBar(false);
    }

    public getServiceTypeLabel(serviceType: number): string {
        return Utils.getServiceTypeLabel(serviceType);
    }
}
